import Vue from 'vue'
import Antd from 'ant-design-vue'
import './antVariables.less'
import './config.js'

Vue.use(Antd)
